import React, { useEffect, useState, createContext, useContext } from 'react';
import { Product } from '../types/models';
interface FavoritesContextType {
  favorites: string[]; // Array of product IDs
  toggleFavorite: (productId: string) => void;
  isFavorite: (productId: string) => boolean;
  getFavoriteProducts: (allProducts: Product[]) => Product[];
  favoritesCount: number;
}
const FavoritesContext = createContext<FavoritesContextType | undefined>(undefined);
export function FavoritesProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [favorites, setFavorites] = useState<string[]>([]);
  // Load favorites from localStorage on mount
  useEffect(() => {
    const storedFavorites = localStorage.getItem('bloom-pop-favorites');
    if (storedFavorites) {
      setFavorites(JSON.parse(storedFavorites));
    }
  }, []);
  // Save favorites to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('bloom-pop-favorites', JSON.stringify(favorites));
  }, [favorites]);
  const toggleFavorite = (productId: string) => {
    setFavorites(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };
  const isFavorite = (productId: string) => {
    return favorites.includes(productId);
  };
  const getFavoriteProducts = (allProducts: Product[]) => {
    return allProducts.filter(product => favorites.includes(product.id));
  };
  return <FavoritesContext.Provider value={{
    favorites,
    toggleFavorite,
    isFavorite,
    getFavoriteProducts,
    favoritesCount: favorites.length
  }} data-id="element-1191">
      {children}
    </FavoritesContext.Provider>;
}
export function useFavorites() {
  const context = useContext(FavoritesContext);
  if (context === undefined) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
}